import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ez-expandable',
  imports: [],
  templateUrl: './expandable.component.html',
  styleUrl: './expandable.component.scss',
})
export class ExpandableComponent {
  @Input({ required: true }) header: string;
  @Output() isDetailsOpen = new EventEmitter<boolean>();
  @ViewChild('details') details: ElementRef<HTMLDetailsElement>;
  @ViewChild('summary') summary: ElementRef<HTMLDetailsElement>;

  onToggle() {
    const isDetailsOpen = this.details.nativeElement.open;
    this.isDetailsOpen.emit(isDetailsOpen);
  }
  close() {
    if (this.details.nativeElement.open) {
      this.summary.nativeElement.click();
    }
  }
}
